import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { AnalyticsModule } from '@ddt-web/analytics';
import { SharedModule } from '@ddt-web/common';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';

import { TipsComponent } from './tips.component';

@NgModule({
	declarations: [TipsComponent],
	imports: [
		CommonModule,
		CwpNgFrameworkModule,
		SharedModule,
		AnalyticsModule,
		GenericDirectivesModule
	],
	exports: [
		TipsComponent
	]
})
export class TipsModule { }
